type RuntimeDiagnostic = { code: string; screen: string; version: string };

/** Never send exception text, URLs, wallet payloads or the DOM to diagnostics. */
export function installRuntimeDiagnostics(target: Window, report: (value: RuntimeDiagnostic) => void): () => void {
  const sent = new Set<string>();
  const send = (code: string) => {
    if (sent.has(code)) return;
    sent.add(code);
    const screen = target.document.querySelector<HTMLElement>(".game-shell")?.dataset.section ?? "boot";
    const major = /(?:Chrome|Chromium)\/(\d{1,3})\./.exec(target.navigator.userAgent)?.[1];
    report({ code, screen: /^[a-z-]{1,32}$/.test(screen) ? screen : "unknown", version: major ? `chromium-${major}` : "other" });
  };
  const error = (event: Event) => { if (event instanceof ErrorEvent) send("RUNTIME_EXCEPTION"); };
  const rejection = () => send("RUNTIME_REJECTION");
  const lost = () => send("CANVAS_CONTEXT_LOST");
  target.addEventListener("error", error);
  target.addEventListener("unhandledrejection", rejection);
  target.document.addEventListener("contextlost", lost, true);
  target.document.addEventListener("webglcontextlost", lost, true);
  return () => {
    target.removeEventListener("error", error);
    target.removeEventListener("unhandledrejection", rejection);
    target.document.removeEventListener("contextlost", lost, true);
    target.document.removeEventListener("webglcontextlost", lost, true);
  };
}
